import { render, staticRenderFns } from "./DutyItem.vue?vue&type=template&id=543be1f0&"
import script from "./DutyItem.vue?vue&type=script&lang=js&"
export * from "./DutyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports